export const SESSION_TIMEOUT = 'Forgotpwd/SESSION_TIMEOUT'

export const INIT = 'Forgotpwd/INIT'
export const FETCH_DATA_ERROR = 'Forgotpwd/FETCH_DATA_ERROR'
export const FETCH_DATA_SUCCESS = 'Forgotpwd/FETCH_DATA_SUCCESS'

export const SUBMIT_PASSWORD = 'Forgotpwd/SUBMIT_PASSWORD'
export const SUBMIT_PASSWORD_SUCCESS = 'Forgotpwd/SUBMIT_PASSWORD_SUCCESS'
export const SUBMIT_PASSWORD_ERROR = 'Forgotpwd/SUBMIT_PASSWORD_ERROR'

export const SUBMIT_VERIFICATION_INIT = 'Forgotpwd/SUBMIT_VERIFICATION_INIT'
export const SUBMIT_VERIFICATION_INIT_SUCCESS = 'Forgotpwd/SUBMIT_VERIFICATION_INIT_SUCCESS'
export const SUBMIT_VERIFICATION_INIT_ERROR = 'Forgotpwd/SUBMIT_VERIFICATION_INIT_ERROR'

export const SEND_CHALLENGE = 'Forgotpwd/SEND_CHALLENGE'
export const SEND_CHALLENGE_SUCCESS = 'Forgotpwd/SEND_CHALLENGE_SUCCESS'
export const SEND_CHALLENGE_ERROR = 'Forgotpwd/SEND_CHALLENGE_ERROR'
export const ON_NEXT = 'Forgotpwd/ON_NEXT'
export const VERIFY_ACCOUNT_RECOVERY = 'Forgotpwd/VERIFY_ACCOUNT_RECOVERY'
export const VERIFY_ACCOUNT_RECOVERY_SUCCESS = 'Forgotpwd/VERIFY_ACCOUNT_RECOVERY_SUCCESS'
export const VERIFY_ACCOUNT_RECOVERY_ERROR = 'Forgotpwd/VERIFY_ACCOUNT_RECOVERY_ERROR'

export const RESEND_CODE = 'Forgotpwd/RESEND_CODE'
export const RESEND_CODE_SUCCESS = 'Forgotpwd/RESEND_CODE_SUCCESS'
export const RESEND_CODE_ERROR = 'Forgotpwd/RESEND_CODE_ERROR'

export const INIT_USER_APPS = 'Forgotpwd/INIT_USER_APPS'
export const INIT_USER_APPS_SUCCESS = 'Forgotpwd/INIT_USER_APPS_SUCCESS'
export const INIT_USER_APPS_ERROR = 'Forgotpwd/INIT_USER_APPS_ERROR'

export const GET_ACCOUNT_RECOVERY = 'Forgotpwd/GET_ACCOUNT_RECOVERY'
export const GET_ACCOUNT_RECOVERY_SUCCESS = 'Forgotpwd/GET_ACCOUNT_RECOVERY_SUCCESS'
export const GET_ACCOUNT_RECOVERY_ERROR = 'Forgotpwd/GET_ACCOUNT_RECOVERY_ERROR'

export const ACCOUNT_RECOVERY_SELECTION = 'Forgotpwd/ACCOUNT_RECOVERY_SELECTION'

export const CANCEL = 'Forgotpwd/CANCEL'

